export class GeoPoint {
    constructor(latitude, longitude) {
        this.latitude = latitude;
        this.longitude = longitude;
    }
    toJSON() {
        return {
            __type__: 'geopoint',
            latitude: this.latitude,
            longitude: this.longitude,
        };
    }
}
//# sourceMappingURL=geopoint.js.map